/**
 * Directives to handle input and scope.form styling and validation
 */
define(function (require, exports) {
    'use strict';

    var angular = require('angular');

    // @ngInject
    /**
     * @param {ng.ILogService} $log
     */
    exports.metForm = function ($log) {
        return {
            restrict: 'A',
            require: '?form',
            link: function (scope, elem, attrs, ctrl) {
                $log.info('metForm');
                if ('validationOnSubmit' in attrs) {
                    ctrl.validationOnSubmit = true;
                }
                if ('errorMessages' in attrs) {
                    ctrl.errorMessages = attrs.errorMessages;
                }
                elem.on('submit', function () {
                    scope.$broadcast('form:submit');
                });

                if (attrs.changeEvent) {
                    ctrl.changeEvent = attrs.changeEvent;
                }
            }
        };
    };

    // @ngInject
    exports.metInputGroup = function () {
        return {
            restrict: 'A',
            controller: /* @ngInject */ function ($scope, $element) {
                var position = 'pre';
                var elms = $element.find('> *');
                $element.addClass('met-input-group');

                angular.forEach(elms, function (elm) {
                    if (elm.localName === 'input') {
                        this.input = elm;
                        position = 'after';
                    } else {
                        this[position] = this[position] ? this[position] : [];
                        this[position].push(elm);

                    }
                }.bind(this));

            }
        };
    };

    exports.metDisplayOnlyInput = function() {
        return {
            restrict: 'A',
            template: [
                '<input',
                '    type="text"',
                '    ng-model="showValue"',
                '    data-label="{{label}}"',
                '    met-input',
                '    ng-disabled="true">'
            ].join(''),
            scope: {
                showValue: '=',
                label: '@'
            }
        };
    };

    // Fix for dynamic form names for angularjs < 1.3
    exports.metDynamicName = function() {
        return {
            restrict: 'A',
            priority: -1,
            require: ['ngModel'],
            link: function (scope, element, attr, ngModel) {
                ngModel[0].$name = attr.name;
            }
        };
    };

    // @ngInject
    /**
     * @param {ng.ICompileService} $compile
     * @param {ng.ILogService} $log
     */
    exports.metInput = function ($compile, $log, lpCoreBus) {
        return {
            restrict: 'A',
            require: ['ngModel', '^?form', '^?metInputGroup'],
            scope: {
                label: '@',
                errorMessages: '=',
                validationOnBlur: '&',
                parentClass: '='
            },
            link: function (scope, elem, attrs, ctrls) {

                // Stop execution if elem is not an <input>
                if (elem[0].localName !== 'input') {
                    $log.error('Directive metInput: this directive must be applied to an <input> element.\n' +
                        'Aborting directive execution.\n' + elem[0].outerHTML);
                    return false;
                }

                // Stop execution if there's no scope.ngModelCtrl directive attached to the element
                if (!ctrls[0]) {
                    $log.error('Directive metInput: Input field "' + (elem[0].name || 'unknown') + '" has no scope.ngModelCtrl.\n' +
                        'Aborting directive execution.\n' + elem[0].outerHTML);
                    return false;
                }

                // scope.ngModelCtrlController and scope.formController (parent <form> element)
                scope.ngModelCtrl = ctrls[0];
                scope.form = ctrls[1];
                scope.metInputGroup = ctrls[2];



                // Alert that validation only on scope.form submission is not possible
                // and set a variable for validationOnSubmit
                if (!scope.form) {
                    $log.warn('Directive metInput: Input field "' + elem[0].name + '" has no parent form controller.\n' +
                        'On submit validation not possible\n' + elem[0].outerHTML);
                }

                // Check if form has changeEvent attribute and add the event at the attribute
                // to pubsub
                if (scope.form) {
                    setTimeout(function () {
                        if (scope.form.changeEvent) {
                            lpCoreBus.subscribe(scope.form.changeEvent, function () {
                                // scope.ngModelCtrl.$setViewValue(scope.ngModelCtrl.$viewValue);
                            });
                        }
                    }, 0);
                }

                scope.error = {
                    showError: false,
                    errorMessage: 'This is a generic error message'
                };

                /**
                 * Basic Error Messages object
                 * @type {Object}
                 */
                var ErrorMessages = {
                    minlength: 'The value entered is too short',
                    maxlength: 'The value entered is too long',
                    pattern: 'There is an invalid character',
                    required: 'This field is required',
                    min: 'The value entered is below minimum',
                    max: 'The value entered is above maximum'
                };

                if (scope.form) {
                    setTimeout(function () {
                        if (scope.form.errorMessages) {
                            angular.forEach(JSON.parse(scope.form.errorMessages.replace(/'/g, '"')), function (value, key) {
                                ErrorMessages[key] = value;
                                $log.info('metInput: at Input field "' + (elem[0].name || 'unknown') + '", the error message "' + key + '"" was redefined as "' + value + '", as defined by the parent metForm directive.');
                            });
                        }
                    }, 0);
                }

                angular.forEach(scope.errorMessages, function (value, key) {
                    ErrorMessages[key] = value;
                });

                /**
                 * Wrap the input element in divs for styling
                 */
                var parentClass = '';
                if (attrs.parentClass) {
                    parentClass = attrs.parentClass;
                }

                elem.addClass('form-control');

                // If label is missing, add a class to the input element
                if (!scope.label) {
                    scope.label='';
                    elem.addClass('no-label');
                }

                var wrapper = $compile('<div class="metro-form-input form-group ' + parentClass + '">' +
                    '<div class="metro-form-input-item bg-white"></div></div>')(scope);
                elem.wrap(wrapper);

                var asAdd = !!scope.metInputGroup && (scope.metInputGroup.pre || scope.metInputGroup.after);
                if (asAdd) {
                    var inputGroup = angular.element('<div class="input-group"></div>');
                    elem.wrap(inputGroup);
                    elem.before(scope.metInputGroup.pre);
                    elem.after(scope.metInputGroup.after);
                }

                /**
                 * Create and add the error message element
                 */
                var errorElem = $compile('<div ng-if="error.showError" class="help-block">{{error.errorMessage}}</div>')(scope);
                elem.parents('.metro-form-input-item').after(errorElem);

                /**
                 * Create and add the vaidation icon element
                 */
                var iconElem = $compile('<span ng-show="ngModelCtrl.$valid && !ngModelCtrl.$pristine && displayValid" class="form-control-feedback fa" ng-class="{\'fa-check text-success\': ngModelCtrl.$valid}" aria-hidden="true"></span>')(scope);
                elem.parents('.metro-form-input-item').after(iconElem);

                /**
                 * Create and add the label element
                 */
                var labelElem = $compile('<label>' + scope.label + '</label>')(scope);
                elem.after(labelElem);

                /**
                 * Sets the proper error message
                 *  Important: Object.keys(scope.ngModelCtrl.$error)[0]
                 *  gets always the first error captured; to make it get
                 *  the latest value, use [Object.keys(scope.ngModelCtrl.$error).length - 1]
                 *  instead of [0]
                 */
                var setErrorMessage = function () {

                    scope.error.errorMessage = '';
                    scope.valid = true;
                    if (Object.keys(scope.ngModelCtrl.$error).length > 0) {
                        angular.forEach(scope.ngModelCtrl.$error, function (value, key) {
                            if (scope.ngModelCtrl.$error[key]) {
                                scope.error.errorMessage = ErrorMessages[key];
                            }
                        });
                        scope.valid = false;
                    }
                };

                /**
                 * To do: on submit validation
                 * Still not working properly
                 */
                scope.$on('form:submit', function () {

                    if (scope.form.validationOnSubmit) {
                        setErrorMessage();
                        scope.$apply(function () {
                            scope.displayValid = true;
                            scope.error.showError = true;
                        });
                        scope.form.$submitted = false;
                    }
                });

                /**
                 * Treats validation on keypress
                 */
                var validateOnChange = function () {
                    if (elem.hasClass('isEnabled')) {
                        setErrorMessage();
                        scope.error.showError = false;
                        if (!scope.ngModelCtrl.$valid && !scope.ngModelCtrl.$pristine && !('validationOnBlur' in attrs) && !scope.form.validationOnSubmit) {
                            scope.error.showError = true;
                        }
                    }
                };

                /**
                 * OnBlur validation
                 */
                elem.on('blur', function () {


                    if ('validationOnBlur' in attrs && !scope.form.validationOnSubmit) {

                        setErrorMessage();
                        scope.error.showError = false;
                        if (!scope.ngModelCtrl.$valid && !scope.ngModelCtrl.$pristine) {
                            scope.$apply(function () {
                                scope.error.showError = true;
                            });
                        }
                    }
                });

                /**
                 * On Model Value Change updates error message display
                 */
                scope.$watch(
                    function () {
                        return scope.ngModelCtrl.$modelValue;
                    },
                    function handleModelValueChange(newValue) {


                        if(!newValue && scope.error.showError) {

                            scope.error.showError = false;
                        }
                    });

                /**
                 * OnChange validation
                 */
                scope.$watch(
                    function () {
                        return scope.ngModelCtrl.$viewValue;
                    },
                    function handleValueChange(newValue, oldValue) {
                        if (newValue !== oldValue) {
                            scope.ngModelCtrl.$setViewValue(scope.ngModelCtrl.$viewValue);
                        }

                        /**
                         * Yeah, we know this is horrible
                         * however it's the only way to avoid
                         * the wrong activation!
                         * Good luck to find another approach ;-)
                         */
                        setTimeout(function () {
                            if (
                                newValue === oldValue &&
                                oldValue !== '' &&
                                oldValue !== null &&
                                oldValue !== undefined
                            ) {
                                scope.valid = true;
                                scope.ngModelCtrl.$setViewValue(scope.ngModelCtrl.$viewValue);
                            }

                            validateOnChange();

                            if (elem.hasClass('isEnabled')) {
                                scope.valid = false;

                                if (scope.ngModelCtrl.$valid) {
                                    scope.valid = true;
                                }
                            } else {
                                scope.valid = true;
                            }

                            scope.$apply();
                        }, 20);
                    }
                );

                /**
                 * Watch for disabled property change and updates dirtyness
                 */
                scope.$watch(
                    function () {
                        return elem.prop('disabled');
                    },
                    function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            if (newValue) {
                                elem.removeClass('isEnabled');
                            } else {
                                elem.addClass('isEnabled');
                            }
                        }
                    }
                );

                scope.$watch(
                    function () {
                        return scope.ngModelCtrl.$error;
                    },
                    function handleErrorChange() {
                        setTimeout(function () {
                            setErrorMessage();

                            scope.error.showError = false;
                            if (!scope.ngModelCtrl.$valid && !scope.ngModelCtrl.$pristine) {
                                scope.error.showError = true;
                            }

                            scope.$apply();
                        }, 20);
                    },
                    true
                );
            }
        };
    };

    // @ngInject
    /**
     * @param {ng.IFilterService} $filter
     * @param {ng.IParseService} $parse
     * @param {ng.ILocaleService} $locale
     */
    exports.metNumber = function ($filter, $parse, $locale, lpCoreI18n) {

        function valueFormatter(value, fraction, currency, disabled) {
            // make sure we have number value
            if(angular.isString(value)) {
                value = Number(value.replace(/[^0-9.\-+e]+/g, ''));
            }

            return disabled && currency
                ? lpCoreI18n.formatCurrency(value, currency)
                : $filter('number')(value, fraction);
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {

                // get thousands separator and set number of digits after decimal point
                var replaceRegex = new RegExp($locale.NUMBER_FORMATS.GROUP_SEP, 'g');
                var fraction = 2;

                ngModelCtrl.$parsers.push(function (viewValue) {
                    if (viewValue) {
                        // remove thousands separator
                        var newVal = viewValue.toString().replace(replaceRegex, '');
                        var newValAsNumber = parseFloat(newVal);

                        // Do not check validity if disabled since when it's disabled we show the currency symbol
                        if (!element.prop('disabled')) {

                            // check if new value is numeric, and set control validity
                            if (isNaN(newValAsNumber)) {
                                ngModelCtrl.$setValidity('numeric', false);
                            } else {
                                newVal = newValAsNumber.toFixed(fraction);
                                ngModelCtrl.$setValidity('numeric', true);
                            }

                            //check if new value is larger than the max value and set validity
                            if (attrs.max && newValAsNumber > attrs.max) {
                                ngModelCtrl.$setValidity('max', false);
                            } else if (attrs.max) {
                                ngModelCtrl.$setValidity('max', true);
                            }

                            //check if new value is smaller than the min value and set validity
                            if (attrs.min && newValAsNumber < attrs.min) {
                                ngModelCtrl.$setValidity('min', false);
                            } else if (attrs.min) {
                                ngModelCtrl.$setValidity('min', true);
                            }

                        }

                        return newVal;
                    }

                });

                ngModelCtrl.$formatters.push(function (data) {

                    return valueFormatter(
                            data,
                            fraction,
                            attrs.currency,
                            element.prop('disabled')
                        );
                });

                element.bind('focus', function () {
                    element.val(ngModelCtrl.$modelValue);
                });

                function blurHandler() {
                    var formatted = valueFormatter(
                            ngModelCtrl.$modelValue,
                            fraction,
                            attrs.currency,
                            element.prop('disabled')
                        );

                    ngModelCtrl.$setViewValue(formatted);

                    ngModelCtrl.$render();
                }

                element.bind('blur', blurHandler);

                element.bind('keypress', function(event) {
                    // Code adpated from lp-number-input because it won't
                    // work with other directive in the same element (scope isolation)
                    // and also does not accept decimals
                    // Regular expression for numbers 0..9 (and dot)
                    var digitRegex = new RegExp('4[8-9]|5[0-7]');
                    var isMinus = event.which === 45;
                    var digit = null;
                    var preValue;
                    var input = element[0];

                    // if key pressed not a digit, backspace, delete, enter, tab or function key... block it
                    // check for 37 and 39, the left and right arrow key since some browsers trigger keypress for these
                    if (!event.ctrlKey && !event.metaKey &&
                        !/^(8|9|13|189|190|45|46|37|39)$/.test(event.which || event.keyCode) && !digitRegex.test(event.which) && !isMinus) {
                        return false;
                    }

                    var value = input.value;

                    // Check if a dot is inputted, and if a dot is already at the string, block it
                    if (event.which === 46 && (value.match(/\./g)||[]).length > 0) {
                        return false;
                    }

                    if (digitRegex.test(event.which) || isMinus) {
                        digit = String.fromCharCode(event.which);

                        // Check only if it's the first chracter (this.value is "")
                        if (isNaN(value) && !this.value) {
                            // If minus is the very first character just don't validate
                            if (!isMinus) {
                                value = '';
                            }
                        }

                        preValue = value || this.value;

                        // Additional check for minus character to make sure it can only be the very first character
                        if ( isMinus && (preValue || String(value || this.value).match(/-/g).length) ) {
                            return false;
                        }

                        value = parseInt(preValue + digit, 10);
                    }
                });

                scope.$watch(
                    function () {
                        return element.prop('disabled');
                    },
                    blurHandler
                );
            }
        };
    };

});



// WEBPACK FOOTER //
// ./scripts/directives/metInput/metInput.js